import * as React from 'react';

import {motion} from 'framer-motion';

import {colors} from '../colors/colors';

import {sourceTransition, destinationTransition} from './constants';

import styles from './empty-circle.module.css';

type Props = {
    offsetTop: number;
    isHovered: boolean;
};

const motionVariants = {
    hovered: {
        r: 6,
        fill: colors.blue,
        transition: destinationTransition,
    },
    unhovered: {
        r: 4,
        fill: '#fff',
        transition: sourceTransition,
    },
} as const;

export function AdderCircle({offsetTop, isHovered}: Props) {
    return (
        <div style={{marginTop: offsetTop}} className={styles['empty-circle']}>
            <svg viewBox='0 0 16 16'>
                <motion.circle
                    cx='8'
                    cy='8'
                    r='4'
                    fill='#fff'
                    variants={motionVariants}
                    animate={isHovered ? 'hovered' : 'unhovered'}
                />
                <path stroke='#fff' d='M7.5 5.5 h1 v2 h2 v1 h-2 v2 h-1 v-2 h-2 v-1 h2 z' />
            </svg>
        </div>
    );
}

AdderCircle.defaultProps = {
    offsetTop: 9,
};
